import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { CommonModule, CurrencyPipe, DecimalPipe, NgFor } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FuseCardComponent } from '@fuse/components/card';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { BannerSectionType01Component } from '../../banner-section/banner_section-type01/banner_section-type01.component';
// import { EVENT_PACKAGES } from './event-packages-data';
import { FormsModule } from '@angular/forms';
import { HeadingSectionType01Component } from '../../heading-section/heading_section-type01/heading_section-type01.component';
import { EventEnquireModalComponent } from '../event-enquire-modal/event-enquire-modal.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'app-packages-type02',
    standalone: true,
    imports: [
        MatIconModule,
        DecimalPipe,
        CurrencyPipe,
        MatTooltipModule,
        RouterLink,
        FuseCardComponent,
        BannerSectionType01Component,
        MatSlideToggleModule,
        NgFor, FormsModule, CommonModule, HeadingSectionType01Component
    ],
    templateUrl: './packages-type02.component.html',
    styleUrl: './packages-type02.component.scss',
})
export class PackagesType02Component implements OnInit {

    searchQuery = '';
    selectedLocations: string[] = [];
    selectedPriceRange = '';
    selectedCategory: string[] = [];
    filteredEvents: any[] = [];
    uniqueLocations: string[] = [];
    originalEvents: any[] = [];
    uniqueCategories: string[];

    // EVENT_PACKAGES = EVENT_PACKAGES;
    // filteredPackages = EVENT_PACKAGES;
    fallbackImg: string = 'assets/images/cards/No-Image-Placeholder.png?v=1';

    // sports = ['Rugby', 'Cricket', 'Tennis'];

    selectedSport = 'All';
    priceRanges = [
        { value: '0-100', label: 'Under $100' },
        { value: '100-500', label: '$100 - $500' },
        { value: '500-1000', label: '$500 - $1,000' },
        { value: '1000+', label: 'Over $1,000' }
    ];

    public view: any = {
        visibleEventsCount: 12,
        bundles: {
            featured: { items: [] },
            trending: { items: [] },
            promotion: { items: [] },
            shortStays: { items: [] },
            midweek: { items: [] },
            weekend: { items: [] },
            stay7: { items: [] },
            stay10: { items: [] },
            stay14: { items: [] },
            destination: { items: [] },
            allInclusive: { items: [] },
            bedBreakfast: { items: [] },
            packages: { items: [] },
            eventShows: { items: [] },
            eventSports: { items: [] },
            feedBeachcomber: { items: [] },
            feedThompsonsHoliday: { items: [] },
        },
        filter: {
            options: {
                hotels: [],
                stars: [],
                providers: []
            },
            events: {
                hasTickets: true,
                options: {
                    categories: [],
                    types: [],
                    cities: []
                }
            },
            sort: 1
        },
    };

    constructor(
        public _tfmService: TFMService,
        private route: ActivatedRoute,
        private title: Title,
        private metaService: Meta,
        public sanitizer: DomSanitizer,
        private _cd: ChangeDetectorRef,
        private dialog: MatDialog
    ) { }

    /** Display currency (NAD for site 72, else ZAR). */
    get displayCurrencyCode(): string {
        return this.view?.site?.displayCurrencyCode || 'ZAR';
    }

    startSlideshow(): void {
        setInterval(() => {
            const nextIndex = (this.view.currentImageIndex + 1) % this.view.imageHrefs.length;
            const nextImage = this.view.imageHrefs[nextIndex];

            this.fadeToImage(nextImage);
            this.view.currentImageIndex = nextIndex;
        }, 5000);
    }

    fadeToImage(nextImage: string): void {
        const img = new Image();
        img.src = nextImage;

        img.onload = () => {
            if (this.view.activeLayer === 1) {
                this.view.imageLayer2 = nextImage;
                this.view.activeLayer = 2;
            } else {
                this.view.imageLayer1 = nextImage;
                this.view.activeLayer = 1;
            }
            this._cd.detectChanges();
        };
    }

    ngOnInit(): void {

        this.view.isClient = this._tfmService.view.isClient;

        // this.filterBySport('All');
        this.getEvents('sport');

        this._tfmService.getSite().then(res => {
            this.view.site = res;

            this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
            this._tfmService.log("Events Site", this.view.site.profile);
        });

        this.view.currentImageIndex = 0;
        this.view.activeLayer = 1;
        this.view.imageLayer1 = '';
        this.view.imageLayer2 = '';

        this._tfmService.getContentBySection('events').then((res) => {
            this.view.page = res;
            const images = this.view.page?.content?.images;
            this._tfmService.log("Events Page:", this.view.page);

            if (images && images.length > 0) {
                this.view.imageHrefs = images
                    .map((img: any) => {
                        const viewLink = img._links?.find((link: any) => link.rel === 'view');
                        return viewLink?.href ?? null;
                    })
                    .filter((href: string | null) => href !== null);

                this.view.imageLayer1 = this.view.imageHrefs[0];
                this.startSlideshow();
            }
        });

        this.loadEvents();
    }
    loadEvents() {
        this.originalEvents = this.view?.bundles?.eventSports?.items || [];
        this.filteredEvents = [...this.originalEvents];
        this._tfmService.log('Events loaded:', this.originalEvents);
        this._tfmService.log('Unique locations:', this.uniqueLocations);

    }
    onDropdownChange(filterType: 'type' | 'city', event: Event) {
        const selectElement = event.target as HTMLSelectElement;
        const value = selectElement.value;

        // Set or clear the filter based on the selected value
        this.view.filter.events[filterType] = value || null;
        this.applyEventsFilter();
    }
    toggleFilter(filterType: 'category' | 'type' | 'city', value: string) {
        // If the same value is clicked, unset the filter
        if (this.view.filter.events[filterType] === value) {
            this.view.filter.events[filterType] = null;
        } else {
            this.view.filter.events[filterType] = value;
        }
        this.applyEventsFilter();
    }

    // Modified applyEventsFilter to handle null values
    applyEventsFilter() {
        var filtered = [];

        // Create filter options if not yet
        if (this.view.filter.events.options.types.length == 0) {
            let types: any = [];
            let categories: any = [];
            let cities: any = [];

            this.view.events.results.forEach(event => {
                if (!types.some(x => x.name.toLowerCase() == event.type?.toLowerCase())) {
                    types.push({ name: event.type });
                }
                if (!categories.some(x => x.name.toLowerCase() == event.category?.toLowerCase())) {
                    categories.push({ name: event.category });
                }
                if (event.venue?.city && !cities.some(x => x.name.toLowerCase() == event.venue.city.toLowerCase())) {
                    cities.push({ name: event.venue.city });
                }
            });

            this.view.filter.events.options.types = types;
            this.view.filter.events.options.categories = categories;
            this.view.filter.events.options.cities = cities;
        }

        filtered = this.view.events.results;

        // Apply filters only if they have values
        if (this.view.filter.events.type) {
            filtered = filtered.filter(x => x.type?.toLowerCase() == this.view.filter.events.type.toLowerCase());
        }
        if (this.view.filter.events.category) {
            filtered = filtered.filter(x => x.category?.toLowerCase() == this.view.filter.events.category.toLowerCase());
        }
        if (this.view.filter.events.city) {
            filtered = filtered.filter(x => x.venue?.city?.toLowerCase() == this.view.filter.events.city.toLowerCase());
        }

        if (this.view.filter.events.text) {
            filtered = filtered.filter(x => x.name.toLowerCase().includes(this.view.filter.events.text.toLowerCase()));
        }

        if (this.view.filter.events.dateFrom) {
            filtered = filtered.filter(x => new Date(x.date) >= new Date(this.view.filter.events.dateFrom));
        }
        if (this.view.filter.events.dateTo) {
            filtered = filtered.filter(x => new Date(x.date) <= new Date(this.view.filter.events.dateTo));
        }

        // Transform the filtered events to the bundle format
        const transformedEvents = filtered.map(event => this.transformToBundleFormat(event));

        if (this.view.filter.events.hasTickets) {
            this.view.eventsFiltered = transformedEvents.filter(x => x.tickets && x.tickets.length > 0);
        } else {
            this.view.eventsFiltered = transformedEvents;
        }
    }
    // Update your getEvents method to initialize both filtering systems
    getEvents(type) {
        if (!this.view.eventsSport || !this.view.eventShows) {
            this.view.loadingEvents = true;

            var searchContentEvent = {
                "googlePlaceID": "",
                "location": "",
                "date": new Date(),
                "occupancy": [{ adultCount: 1 }],
                "siteSearchProviders": ""
            };

            this._tfmService.saveSearch(searchContentEvent, 4).subscribe(search => {
                this._tfmService.send({ href: search.url, method: "get" }).subscribe(searchResult => {
                    this._tfmService.filterAndSend(searchResult.content._links, "search-results-golf").subscribe(searchResultEvent => {
                        if (searchResultEvent.data && searchResultEvent.data.length > 0) {
                            searchResultEvent.data.forEach(data => {
                                if (data.provider == "p1-events") {
                                    if (data.results) {
                                        this.view.eventsSports = data.results.filter(x => x.category.toLowerCase() != 'shows');
                                        this.view.eventShows = data.results.filter(x => x.category.toLowerCase() == 'shows');

                                        this.view.bundles.eventShows.items = this.getEventBundles(data.results.filter(x => x.category.toLowerCase() == 'shows'));
                                        this.view.bundles.eventSports.items = this.getEventBundles(data.results.filter(x => x.category.toLowerCase() != 'shows'));
                                    }

                                    this.view.events = data;
                                    this.view.events.results = data.results || [];

                                    // Initialize both filtering systems
                                    this.originalEvents = this.view.bundles.eventSports.items;
                                    this.filteredEvents = [...this.originalEvents];
                                    this.extractUniqueLocations();
                                    this.extractUniqueCategory();

                                    // Initialize admin filter options
                                    if (!this.view.filter.events.options) {
                                        this.view.filter.events.options = { types: [], categories: [], cities: [] };
                                    }

                                    let types: any = [];
                                    let categories: any = [];
                                    let cities: any = [];

                                    this.view.events.results.forEach(event => {
                                        if (!types.some(x => x.name.toLowerCase() == event.type?.toLowerCase())) {
                                            types.push({ name: event.type });
                                        }
                                        if (!categories.some(x => x.name.toLowerCase() == event.category?.toLowerCase())) {
                                            categories.push({ name: event.category });
                                        }
                                        if (event.venue?.city && !cities.some(x => x.name.toLowerCase() == event.venue.city.toLowerCase())) {
                                            cities.push({ name: event.venue.city });
                                        }
                                    });

                                    this.view.filter.events.options.types = types;
                                    this.view.filter.events.options.categories = categories;
                                    this.view.filter.events.options.cities = cities;

                                    this.applyEventsFilter();
                                    if(this.view.isClient) {
                                        this.filterEvents();
                                    }
                                    this.view.loadingEvents = false;
                                }
                            });
                        }
                    });
                });
            });
        }
    }
    getEventBundles(eventCollection) {
        return eventCollection.filter(x => x.tickets && x.tickets.length > 0)
                            .map(event => this.transformToBundleFormat(event));
    }
    transformToBundleFormat(event: any): any {
        return {
            search: {
                name: "Events"
            },
            isEvent: true,
            itineraryID: 0,
            category: event.category,
            date: event.date,
            tickets: event.tickets,
            priceAdvertise: event.tickets?.[0]?.sell || 0,
            currency: event.tickets?.[0]?.currencyCode || '',
            supplierName: event.name,
            supplier: {
                name: event.name,
                place: event.venue?.city || '',
                contentShort: event.tickets?.[0]?.description || '',
                contentHighlights: event.type,
                images: {
                    imageUrlBg: this.sanitizer.bypassSecurityTrustStyle('url(' + (event.tickets?.[0]?.imageUrl || this.fallbackImg) + ')'),
                    rawImageUrl: event.tickets?.[0]?.imageUrl || this.fallbackImg
                }
            }
        };
    }
    extractUniqueLocations() {
        const locations = new Set<string>();
        this.originalEvents.forEach(event => {
            if (event.supplier?.place) {
                locations.add(event.supplier.place);
            }
        });
        this.uniqueLocations = Array.from(locations).sort();
    }
    extractUniqueCategory() {
        const category = new Set<string>();
        this.originalEvents.forEach(event => {
            if (event.supplier?.place) {
                category.add(event.category);
            }
        });
        this.uniqueCategories = Array.from(category).sort();
    }
    toggleLocation(location: string): void {
        const index = this.selectedLocations.indexOf(location);
        if (index >= 0) {
            this.selectedLocations.splice(index, 1);
        } else {
            this.selectedLocations.push(location);
        }
        this.filterEvents();
    }
    toggleCategory(category: string): void {
        const index = this.selectedCategory.indexOf(category);
        if (index >= 0) {
            this.selectedCategory.splice(index, 1);
        } else {
            this.selectedCategory.push(category);
        }
        this.view.visibleEventsCount = 12;
        this.filterEvents();
    }

    clearLocations(): void {
        this.selectedLocations = [];
        this.filterEvents();
    }

    togglePriceRange(range: string) {
        this.selectedPriceRange = this.selectedPriceRange === range ? '' : range;
        this.filterEvents();
    }

    clearPriceRange() {
        this.selectedPriceRange = '';
        this.filterEvents();
    }
    clearCategories() {
        this.selectedCategory = [];
        this.filterEvents();
    }
    // Update your filterEvents method to work with both admin and client views
    filterEvents() {
        let filtered = [];

        // For admin view (using view.eventsFiltered)
        if (!this.view.isClient) {
            filtered = this.view.events.results || [];

            // Apply admin filters
            if (this.view.filter.events.type) {
                filtered = filtered.filter(x => x.type?.toLowerCase() === this.view.filter.events.type.toLowerCase());
            }
            if (this.view.filter.events.category) {
                filtered = filtered.filter(x => x.category?.toLowerCase() === this.view.filter.events.category.toLowerCase());
            }
            if (this.view.filter.events.city) {
                filtered = filtered.filter(x => x.venue?.city?.toLowerCase() === this.view.filter.events.city.toLowerCase());
            }
            if (this.view.filter.events.text) {
                filtered = filtered.filter(x => x.name.toLowerCase().includes(this.view.filter.events.text.toLowerCase()));
            }
            if (this.view.filter.events.dateFrom) {
                filtered = filtered.filter(x => new Date(x.date) >= new Date(this.view.filter.events.dateFrom));
            }
            if (this.view.filter.events.dateTo) {
                filtered = filtered.filter(x => new Date(x.date) <= new Date(this.view.filter.events.dateTo));
            }
            if (this.view.filter.events.hasTickets) {
                filtered = filtered.filter(x => x.tickets && x.tickets.length > 0);
            }

            this.view.eventsFiltered = filtered;
            console.log('-----',this.view.eventsFiltered)
        }
        // For client view (using filteredEvents)
        else {
            filtered = this.originalEvents.filter(event => {
                const matchesSearch = this.searchQuery === '' ||
                    (event.supplier.name?.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
                    (event.supplier.place?.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
                    (event.supplier.contentShort?.toLowerCase().includes(this.searchQuery.toLowerCase()));

                const matchesLocation = this.selectedLocations.length === 0 ||
                    this.selectedLocations.includes(event.supplier.place);

                const matchesCategory = this.selectedCategory.length === 0 ||
                    this.selectedCategory.includes(event.category);

                let matchesPrice = true;
                if (this.selectedPriceRange) {
                    const price = event.priceAdvertise || 0;
                    const [min, max] = this.selectedPriceRange.split('-').map(Number);
                    if (this.selectedPriceRange.endsWith('+')) {
                        matchesPrice = price >= min;
                    } else {
                        matchesPrice = price >= min && price <= max;
                    }
                }

                return matchesSearch && matchesLocation && matchesPrice && matchesCategory;
            });

            this.view.totalFilteredCount = filtered.length;
            this.filteredEvents = filtered.slice(0, this.view.visibleEventsCount);
        }
    }

    loadMore() {
        this.view.visibleEventsCount += 6;
        this.filterEvents();
    }

    enquireEvent(event: any): void {

        const dialogRef = this.dialog.open(EventEnquireModalComponent, {
            width: '800px',
            maxHeight: '95vh',
            data: event,
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('Received booking:', result);
            }
        });
    }
}